import React from "react";
import { FormControl, MenuItem, Select } from "@mui/material";

const MonthSelector = ({ selectedMonth, setSelectedMonth, futureMonths = 0, allowEmpty = false }) => {
	const generateMonthOptions = () => {
		const options = [];
		const now = new Date();

		const addMonth = (offset) => {
			const date = new Date(now.getFullYear(), now.getMonth() + offset, 1);
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, "0");
			options.push({
				value: `${year}-${month}`,
				label: date.toLocaleDateString("en-US", { month: "long", year: "numeric" }),
			});
		};

		addMonth(0);

		for (let i = 1; i <= futureMonths; i++) {
			addMonth(i);
		}

		for (let i = 1; i < 12; i++) {
			addMonth(-i);
		}

		return options;
	};

	const monthOptions = generateMonthOptions();

	return (
		<FormControl size="small" style={{ minWidth: "200px" }}>
			<Select
				value={selectedMonth}
				onChange={(e) => setSelectedMonth(e.target.value)}
				displayEmpty={allowEmpty}
				renderValue={(value) => {
					if (!value && allowEmpty) return "Select month";
					const option = monthOptions.find((o) => o.value === value);
					return option?.label || value;
				}}
				style={{
					background: "var(--bg-card)",
					borderRadius: "var(--radius-md)",
					fontWeight: "600"
				}}
			>
				{allowEmpty && (
					<MenuItem value="">
						<em>Select month</em>
					</MenuItem>
				)}
				{monthOptions.map(option => (
					<MenuItem key={option.value} value={option.value}>
						{option.label}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};

export default MonthSelector;